import Murid from "../../../../../components/categories/siakad/lms/data_murid/Home";
export default function Home() {
  
  return (
    <Murid />
  );
}
